/**
 * Minimal CSV parser. Handles:
 *   - quoted fields ("..."), with embedded quotes ("")
 *   - commas inside quoted fields
 *   - CRLF / LF line endings
 *   - leading / trailing whitespace on cells (preserved inside quotes)
 *
 * Returns rows as string[][] with the header row included as the first row.
 * Caller is responsible for slicing off the header.
 *
 * Not a full RFC-4180 implementation — sufficient for Cronometer + similar
 * spreadsheet exports. If we ever need stream parsing or non-comma
 * delimiters, swap in `papaparse`.
 */

export function parseCsv(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let cell = "";
  let inQuotes = false;
  let i = 0;
  const n = text.length;

  while (i < n) {
    const c = text[i];

    if (inQuotes) {
      if (c === '"') {
        // Look for escaped quote
        if (i + 1 < n && text[i + 1] === '"') {
          cell += '"';
          i += 2;
          continue;
        }
        inQuotes = false;
        i++;
        continue;
      }
      cell += c;
      i++;
      continue;
    }

    if (c === '"') {
      inQuotes = true;
      i++;
      continue;
    }
    if (c === ",") {
      row.push(cell);
      cell = "";
      i++;
      continue;
    }
    if (c === "\r") {
      i++;
      continue;
    }
    if (c === "\n") {
      row.push(cell);
      rows.push(row);
      row = [];
      cell = "";
      i++;
      continue;
    }
    cell += c;
    i++;
  }
  // Final cell + row
  if (cell !== "" || row.length > 0) {
    row.push(cell);
    rows.push(row);
  }
  return rows;
}
